import "./select.css"
import ListSelect from "../components/child/ListSelect"
import BuildingSelect from "./child/Select/BuildingSelect/BuildingSelect"
import TrainSelect from "../components/child/Select/TrainSelect"
import {mainSelect} from "../data/selectOptions"
import React, {useState} from "react"
import Party from "./child/Select/Party/Party"
import Upgrade from "./child/Select/Upgrade/Upgrade"
import Research from "./child/Select/Research/Research"

const Select = (props) => {

    const selectList = mainSelect

    const[selectValue, setSelectValue] = useState("")
    
    const handleSelectValue = event => {
        setSelectValue(event.target.value)
    }

    function addItemTrain (newItem) {
        props.addItem(newItem)
    }
    function addItemParty (newItem) {
        props.addItem(newItem)
    }
    function addItemBuilding (newItem) {
        props.addItem(newItem)
    }
    function addItemUpgrade (newItem) {
        props.addItem(newItem)
    }
    function addItemResearch (newItem) {
        props.addItem(newItem)
    }

    

    

return (
    <div className="select" >
        <ListSelect label="...you want..." selectList={selectList}  handleSelectValue={handleSelectValue}/>
        {selectValue ==="1" ? (
            <BuildingSelect addItem={addItemBuilding} />
        ) : 
        selectValue ==="2" ? (
            <TrainSelect addItem={addItemTrain} />
        ) :
        selectValue ==="3" ? (
            <Party addItem={addItemParty} />
        ) :
        selectValue ==="4" ? (
            <Upgrade addItem={addItemUpgrade} />
        ) :
        selectValue ==="5" ? (
            <Research addItem={addItemResearch}/>
        ) : null }

    </div>
)

}
export default Select